import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_WEIGHTCALC_REQUEST,
  ADD_WEIGHTCALC_SUCCESS,
  ADD_WEIGHTCALC_FAILURE,
  UPDATE_WEIGHTCALC_REQUEST,
  UPDATE_WEIGHTCALC_SUCCESS,
  UPDATE_WEIGHTCALC_FAILURE,
  DELETE_WEIGHTCALC_REQUEST,
  DELETE_WEIGHTCALC_SUCCESS,
  DELETE_WEIGHTCALC_FAILURE,
  GET_WEIGHTCALC_REQUEST,
  GET_WEIGHTCALC_SUCCESS,
  GET_WEIGHTCALC_FAILURE,
} from "../constants/weightCalcConstant";

export const addWeightCalcAction = (weightCalcData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_WEIGHTCALC_REQUEST });
    const url = ApiUrl.addWeightCalc;
    const { data } = await axios.post(url, weightCalcData);

    if (data.success) {
      dispatch({
        type: ADD_WEIGHTCALC_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_WEIGHTCALC_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);
    dispatch({
      type: ADD_WEIGHTCALC_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });
    return false;
  }
};

export const updateWeightCalcAction = (id, weightCalcDetails) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_WEIGHTCALC_REQUEST });
    const URL = `${ApiUrl.updateWeightCalc}?id=${id}`; 
    const { data } = await axios.put(URL, weightCalcDetails);

    if (data.success) {
      dispatch({
        type: UPDATE_WEIGHTCALC_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: UPDATE_WEIGHTCALC_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error.response ? error.response.data : "Unknown error");
    dispatch({
      type: UPDATE_WEIGHTCALC_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });
    return false;
  }
};

export const deleteWeightCalcAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_WEIGHTCALC_REQUEST });
    const URL = `${ApiUrl.deleteWeightCalc}?id=${id}`; 
    const { data } = await axios.delete(URL);

    if (data.success) {
      dispatch({
        type: DELETE_WEIGHTCALC_SUCCESS,
        payload: data.success,
      });
      return true;
    } else {
      dispatch({
        type: DELETE_WEIGHTCALC_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error.response ? error.response.data : "Unknown error");
    dispatch({
      type: DELETE_WEIGHTCALC_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });
    return false;
  }
};

export const getWeightCalcActionFn = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_WEIGHTCALC_REQUEST });
    const URL = `${ApiUrl.getWeightCalcById}?id=${id}`; 
    const { data } = await axios.get(URL);

    if (data.success) {
      dispatch({
        type: GET_WEIGHTCALC_SUCCESS,
        payload: data.data, 
      });
      return data;
    } else {
      dispatch({
        type: GET_WEIGHTCALC_FAILURE,
        payload: data,
      });
      return data;
    }
  } catch (error) {
    console.error("Error:", error.response ? error.response.data : "Unknown error");
    dispatch({
      type: GET_WEIGHTCALC_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });
    return error.response ? error.response.data : "Unknown error";
  }
};
